import { Controller } from "stimulus";

const TYPE_SUMMARIES = {
  residency:
    "Field hours, PPM, rating tool, GRS requirements, learner enrollment, xAPI alerts, and attendance notifications.",
  clinical:
    "Required hours, attendance, patient encounters, supervisor signatures, shift rating tool, and attendance notifications.",
};

export default class extends Controller {
  static targets = [
    "typeInput",
    "residencySection",
    "clinicalSection",
    "notificationsSection",
    "typeSummary",
    "typeCard",
    "submitButton",
    "typeRequiredNotice",
    "typePicker",
  ];

  connect() {
    this.updateSections();
  }

  updateSections() {
    const type = this.selectedType();
    const typeSelected = this.typeIsSelected(type);

    this.updateTypeCards(type);
    this.toggleSection(this.residencySectionTarget, type === "residency");
    this.toggleSection(this.clinicalSectionTarget, type === "clinical");
    this.toggleSection(
      this.notificationsSectionTarget,
      type === "residency" || type === "clinical"
    );
    this.updateSubmitState(typeSelected);

    if (this.hasTypeSummaryTarget) {
      this.typeSummaryTarget.textContent = typeSelected
        ? TYPE_SUMMARIES[type]
        : "";
    }
  }

  selectedType() {
    const checked = this.typeInputTargets.find((input) => input.checked);
    return checked ? checked.value : null;
  }

  typeIsSelected(type) {
    return type === "residency" || type === "clinical";
  }

  updateSubmitState(typeSelected) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !typeSelected;
    }

    if (this.hasTypeRequiredNoticeTarget) {
      this.typeRequiredNoticeTarget.classList.toggle("hidden", typeSelected);
    }

    if (this.hasTypePickerTarget) {
      this.typePickerTarget.classList.toggle(
        "course-type-picker--required",
        !typeSelected
      );
    }
  }

  updateTypeCards(type) {
    if (!this.hasTypeCardTarget) return;

    this.typeCardTargets.forEach((card) => {
      const selected = card.dataset.courseType === type;
      card.classList.toggle("course-type-card--selected", selected);
    });
  }

  toggleSection(section, visible) {
    section.classList.toggle("hidden", !visible);
    section.querySelectorAll("input, select, textarea, button").forEach((el) => {
      if (el.type === "hidden") return;
      el.disabled = !visible;
    });
  }
}
